(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/hooks/hooks.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/hooks/hooks.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useRef = _React.useRef;
const useResizeTick = () => {
  const _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    resizeTick = _useState2[0],
    setResizeTick = _useState2[1];
  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }
    const onResize = _.throttle(() => {
      setResizeTick(currentTick => currentTick + 1);
    }, 50);
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      onResize.cancel();
    };
  }, []);
  return resizeTick;
};
const useIsMounted = () => {
  const mountedRef = useRef(false);
  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);
  return useCallback(() => mountedRef.current, []);
};
const useBreakpoints = () => {
  const _useState3 = useState(svs.core.detect.breakpoint.current),
    _useState4 = _slicedToArray(_useState3, 2),
    breakpoint = _useState4[0],
    setBreakPoint = _useState4[1];
  useEffect(() => {
    const listener = breakpoint => {
      setBreakPoint(breakpoint.current);
    };
    svs.core.detect.breakpoint.on('change', listener);
    return () => svs.core.detect.breakpoint.off('change', listener);
  }, []);
  return breakpoint; 
};
setGlobal('svs.tickets.next.hooks.useResizeTick', useResizeTick);
setGlobal('svs.tickets.next.hooks.useIsMounted', useIsMounted);
setGlobal('svs.tickets.next.hooks.useBreakpoints', useBreakpoints);

 })(window);